<!-- 巡检概览 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <div class="base-box">
        <div class="base-item" v-for="item in list1" :key="item.title">
          <div class="base-text">
            <div class="title">{{item.title}}</div>
            <div class="num"><i>{{item.num}}</i></div>
          </div>
          <div class="base-img">
            <img src="@/assets/xj4.png" alt="" />
          </div>
        </div>
      </div>
      <div class="center-content">
        <div class="center-box">
          <div class="center-item" v-for="item in list" :key="item.title">
            <div class="title">{{item.title}}</div>
            <div class="num">{{item.num}}</div>
            <div class="hb" :style="{color: item.hb==0?'#fff':item.hb<1?'red':'yellowgreen'}" v-if="item.hb>0">{{ $t('环比') }}+{{(item.hb*100).toFixed(2)}}%</div>
            <div class="hb" :style="{color: item.hb==0?'#fff':item.hb<1?'red':'yellowgreen'}" v-else>{{ $t('环比') }}{{(item.hb*100).toFixed(2)}}%</div>
          </div>
        </div>
        <div class="bottom-img">
          <img src="@/assets/xj3.png" alt="" />
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
  import { postAction } from '@/api/manage'
  export default{
    data(){
      return{
        title: this.$t('本月任务'),
        url: {
          indexTodayToDoTaskByUser: "/jeecg-engineering/inspection/inspectionTask/LargeScreenTodayDTicketsNum",
          indexTodayDoneTaskByUser: "/jeecg-engineering/inspection/inspectionTask/LargeScreenTodayUnToDo",
          indexWillEndTaskByUser: "/jeecg-engineering/inspection/inspectionTask/LargeScreenTodayWillEndTickets",
          LargeScreenSumMonth:"/jeecg-engineering/inspection/inspectionTask/LargeScreenSumMonth"
        },
        list: [
          {title:this.$t('当日巡检任务数'),num:0,hb:0},
          {title:this.$t('当日未巡检任务数'),num:0,hb:0},
          {title:this.$t('当日即将过期任务数'),num:0,hb:0},
        ],
        list1: [
          {title:this.$t('计划巡检'),num:0},
          {title:this.$t('实际巡检'),num:0},
          {title:this.$t('计划保养'),num:0},
          {title:this.$t('实际保养'),num:0},
        ]
      }
    },
    methods:{
      init(){
        this.getTodayToDoTaskByUser();
        this.getTodayDoneTaskByUser();
        this.getWillEndTaskByUser();
        this.getData();
      },
      // 当日巡检任务数
      getTodayToDoTaskByUser(){
        postAction(this.url.indexTodayToDoTaskByUser,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.list[0].num = data.toDo;
            this.list[0].hb = data.compareToDoRate;
          }
        })
      },
      // 未巡检任务数
      getTodayDoneTaskByUser(){
        postAction(this.url.indexTodayDoneTaskByUser,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.list[1].num = data.done;
            this.list[1].hb = data.compareDoneRate;
          }
        })
      },
      // 即将过期任务数
      getWillEndTaskByUser(){
        postAction(this.url.indexWillEndTaskByUser,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.list[2].num = data.willEnd;
            this.list[2].hb = data.compareWillEndRate;
          }
        })
      },
      getData(){
        postAction(this.url.LargeScreenSumMonth,{queryType:2}).then(res=>{
          if(res.success){
            var data = res.result;
            this.list1[0].num = data.inspectionPlanNum;
            this.list1[1].num = data.inspectionFinishNum;
            this.list1[2].num = data.maintenancePlanNum;
            this.list1[3].num = data.maintenanceFinishNum;
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .base-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    height: 35%;
  
    .base-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 18%;
      height: 100%;
      position: relative;
  
      .base-img {
        width: 100%;
        height: 120%;
        position: relative;
  
        img {
          width: 100%;
          height: 100%;
        }
      }
  
      .base-text {
        text-align: center;
        font-size: 18px;
        z-index: 99;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        
        .num{
          font-size: 25px;
          font-family: fantasy;
        }
      }
    }
  }
  .center-content{
    height: 50%;
    padding: 10px;
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    .center-box{
      display: flex;
      justify-content: space-evenly;
      // height: 70%;
      width: 100%;
      .center-item{
        width: 25%;
        text-align: center;
        border: 1px solid #00FAFE;
        padding: 20px 10px;
        border-radius: 2px;
        .title{
          font-size: 20px;
          color: aqua;
        }
        .hb{
          height: 21px;
          font-size: 14px;
          color: yellowgreen;
        }
        .num{
          font-family: 'ds-digital-bold';
          color: #fff;
          font-size: 45px;
        }
      }
    }
    .bottom-img{
      position: absolute;
      z-index: 99;
      top: 45%;
      left: 50%;
      transform: translate(-50%, 0%);
    }
  }
</style>